module.exports = __webpack_public_path__ + "static/img/042_8.986374b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/042_8.jpg
// module id = 7SVU
// module chunks = 1